module.exports = __webpack_public_path__ + "static/works-fs-biz-card-6e4170bc8e4c9979fb35d5ba5de788a4.jpg";